"use strict";

import React from 'react';
import formatPhoneNumber from "../../formatPhoneNumber";

const AccountAddressDisplay = ({address={}, email='', mailToEmail=false,
                               className='', addressLineClassName='', style={}}) => {
    const addressLineClasses = `account__address__line ${addressLineClassName}`;
    const hasAddressInfo = !!address && !!Object.getOwnPropertyNames(address).length;
    if(hasAddressInfo){
        return (
            <div className={className} style={style}>
                { !!address.company_name &&
                <p className={addressLineClasses}>
                    <strong>{address.company_name}</strong>
                </p>
                }
                { !!email &&
                <p className={addressLineClasses}>
                    {mailToEmail && <a href={'mailto:'+email}>{email}</a> || email}
                </p>
                }
                {!!address.f_name &&
                <p className={addressLineClasses}>
                    { !!address.attention
                        ? address.attention
                        : `${address.f_name} ${!!address.l_name ? address.l_name : ''}`
                    }
                </p>
                }
                { !!address.address &&
                <p className={addressLineClasses}>
                    {address.address}
                </p>
                }
                { !!address.address2 &&
                <p className={addressLineClasses}>
                    {address.address2}
                </p>
                }
                <p className={addressLineClasses}>
                    {address.city}{ !!address.state && `, ${address.state}`} {address.zip5}
                    {!!address.zip4 && ` - ${address.zip4}`}
                </p>
                { !!address.phone &&
                <p className={addressLineClasses}>
                    <strong>Phone:</strong> { formatPhoneNumber(address.phone) }
                </p>
                }
                { !!address.phone_ext &&
                <p className={addressLineClasses}>
                    <strong>Ext:</strong> {address.phone_ext}
                </p>
                }
                { !!address.fax &&
                <p className={addressLineClasses}>
                    <strong>Fax:</strong> { formatPhoneNumber(address.fax) }
                </p>
                }
                { !!address.location_class &&
                <p className={addressLineClasses}>
                    <strong>Location Type:</strong> {address.location_class}
                </p>
                }
            </div>
        );
    }
    return null;
};

export default AccountAddressDisplay;
